import PageComponent from "components/Page";

import SelectDateRange from "components/SelectDateRange";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";
import ButtonIcon from "components/ButtonIcon";
import Table from "components/Table";
import NewFundDialog from "pages/expenses/components/newFundDialog";

import './index.less';
import './themes/default.less';

export default class Expenses extends PageComponent {

    constructor(props) {
        super(props);

        this.tableMap = {
            time: {
                label: "main.time",
                size: "103px",
            },
            pacient: {
                label: "clientStatuses.PERMANENT"
            },
            sum: {
                label: "main.sum",
                size: "120px",
                callback: this.raporSumCell.bind(this),
            }
        };

        this.tableMap2 = {
            time: {
                label: "main.time",
                size: "103px",
            },
            created: {
                label: "main.createBy",
                size: "115px",
            },
            comment: {
                label: "client.comment"
            },
            sum: {
                label: "main.sum",
                size: "120px",
                callback: this.raporSumCell.bind(this),
            }
        };

        this.items0 = [
            { time: "8:40", pacient: "Филатова П.А.", sum: "+ 5 000 ₽" },
            { time: "12:50", pacient: "Симонов П.К.", sum: "+ 10 000 ₽" },
            { time: "13:30", pacient: "Рябинин Д.Т.", sum: "+ 15 000 ₽" },
        ];

        this.items1 = [
            { time: "9:30", pacient: "Филатова П.А.", sum: "- 3 300 ₽" },
            { time: "17:44", pacient: "Симонов П.К.", sum: "- 7 600 ₽" },
        ];

        this.items2 = [
            { time: "11:37", created: "Дубова А.К.", comment: "Возврат за ремонт кондиционера", sum: "+ 15 350 ₽" },
        ];

        this.items3 = [
            { time: "11:37", created: "Дубова А.К.", comment: "Покупка мороженого для пациентов", sum: "- 2 574 ₽" },
        ];

        this.items4 = [
            { time: "18:00", created: "Дубова А.К.", comment: "Округление копеек", sum: "- 0.57 ₽" },
            { time: "18:01", created: "Дубова А.К.", comment: "По факту на конец дня", sum: "- 100 ₽" },
        ];

        this.itemsPeriod = [
            { name: this.tr("expenses.balanceBeginning") },
            { name: this.tr("expenses.payment") },
            { name: this.tr("expenses.refund") },
            { name: this.tr("expenses.incoming") },
            { name: this.tr("expenses.spending") },
            { name: this.tr("expenses.adjustment") },
            { name: this.tr("expenses.collection") },
            { name: this.tr("expenses.balanceEnd") }
        ];

        this.state = {
            ...this.state,
            selectedStartDate: new Date(),
            selectedEndDate: null,
            isLeftmost: true,
            openRow: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
            }
        };
    }

    get dialogsMap() {
        return {
            "newFund": NewFundDialog,
        };
    }

    getHeaderText() {
        const { selectedStartDate, selectedEndDate } = this.state;
        const sdate = this._helper.date.toStr(selectedStartDate, 'DD MMMM YYYY');
        const sdateshort = this._helper.date.toStr(selectedStartDate, 'DD MMMM');
        if (selectedEndDate !== null) {
            const edate = this._helper.date.toStr(selectedEndDate, 'DD MMMM YYYY');
            return `${this.tr("expenses.cashFlowPeriod")} ${sdateshort} - ${edate}`;
        }

        return `${this.tr("expenses.cashFlowHand")} ${sdate}`;
    }

    handleScrollX(scrollLeft) {
        if (scrollLeft === 0)
            this.changeState("isLeftmost", true);
        else
            this.changeState("isLeftmost", false);
    }

    onForm(selectedRange) {
        const { selectedStartDate, selectedEndDate } = selectedRange;
        this.setState({ selectedStartDate, selectedEndDate });
    }

    onOpenRow(index) {
        const { openRow } = this.state;
        this.changeState("openRow", { ...openRow, [index]: !openRow[index] });
    }

    getTableMap() {
        const tableMap = {
            name: {
                label: "expenses.stream",
                size: "300px"
            }
        };
        return tableMap;
    }

    raporSumCell(value, it, info) {
        const { bold } = info;
        let color = "";
        const bl = bold ? "text p1SemiBold" : "";

        if ((value + "").includes("+")) color = "green";
        else if ((value + "").includes("-")) color = "red";

        return (<div className={`raporSumCell ${color} ${bl}`}>{value}</div>);
    }

    generingMap() {
        const { selectedStartDate, selectedEndDate } = this.state;
        const currentDate = new Date(selectedStartDate);
        let obj = {};
        while (currentDate <= selectedEndDate) {
            const name = this._helper.date.toStr(currentDate, 'DDMMYYY');
            const label = this._helper.date.toStr(currentDate, 'DD.MM');
            obj = {
                ...obj, [`sum${name}`]: {
                    label: label,
                    size: "100px",
                    callback: this.raporSumCell.bind(this)
                }
            };
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return obj;
    }

    generingContent() {
        const { selectedStartDate, selectedEndDate } = this.state;
        const currentDate = new Date(selectedStartDate);
        const dates = [];
        while (currentDate <= selectedEndDate) {
            const name = this._helper.date.toStr(currentDate, 'DDMMYYY');
            dates.push({ [`sum${name}`]: "- 30 000 r" });
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    }

    renderDataTable(i) {
        const { openRow } = this.state;

        let map = {};
        if (i === 0 || i === 1)
            map = this.tableMap;
        else
            map = this.tableMap2;


        return (<div className={`expTable flex col gap16 flex1 transit04 ${openRow[i] ? "active" : ""}`}>
            <Table
                map={map}
                items={this["items" + i]}
                scrollNo={true}
            />
            <div></div>
        </div>);
    }

    renderExpandeRow(title, value, color, i) {
        const { openRow } = this.state;

        return (<div className="rowExp flex col">
            <div className="flex between text p1 flex1">
                <div className="flex centerV">
                    <div className="cellButton">
                        <ButtonIcon
                            name={openRow[i] ? "arrowUp" : "arrowDown"}
                            type={openRow[i] ? "expande" : "stroke"}
                            onClick={this.onOpenRow.bind(this, i)} />
                    </div>
                    <div className="cell">{this.tr(title)}</div>
                </div>
                <div className={`cell ${color}`}>{value}</div>
            </div>
            {this.renderDataTable(i)}
        </div>);
    }

    renderRow(title, value, isHeader) {
        return (<div className={`rowExp text p1SemiBold ${isHeader ? "thead pos sticky" : ""}`}>
            <div className="flex between">
                <div className="cell">{this.tr(title)}</div>
                <div className="cell">{value}</div>
            </div>
        </div>);
    }

    renderTablePeriod() {
        const { selectedEndDate, isLeftmost } = this.state;

        let tableMap = this.getTableMap();
        const cont = this.generingContent();

        if (selectedEndDate !== null) {
            const map = this.generingMap();
            tableMap = { ...tableMap, ...map };
            this.itemsPeriod = this.itemsPeriod.map(it => {
                cont.forEach(item => {
                    it = { ...it, ...item };
                });
                return it;
            });

        }

        return (<div className={`tableExpenses flex flex1 ${!isLeftmost ? "shadow" : ""}`}>
            <Table
                map={tableMap}
                items={this.itemsPeriod}
                handleScrollX={this.handleScrollX.bind(this)}
            />
        </div>);
    }

    renderTable() {
        return (<div className="tableExpenses rad8 flex1 flex col minH0 pos rel scrolling">
            <div className="table w100 pos abs sideAll expande">
                {this.renderRow("expenses.balanceBeginning", "9 967,57 ₽", true)}
                {this.renderExpandeRow("expenses.payment", "+ 20 000 ₽", "green", 0)}
                {this.renderExpandeRow("expenses.refund", "- 10 000 ₽", "red", 1)}
                {this.renderExpandeRow("expenses.incoming", "+ 15 350 ₽", "green", 2)}
                {this.renderExpandeRow("expenses.spending", "- 2 574 ₽", "red", 3)}
                {this.renderExpandeRow("expenses.adjustment", "- 100.57 ₽", "red", 4)}
                {this.renderRow("expenses.collection", "0 ₽")}
                {this.renderRow("expenses.balanceEnd", "32 643 ₽")}
            </div>
        </div>);
    }

    renderPage() {
        const { selectedEndDate } = this.state;

        return (
            <div className="flex1 flex col gap16">
                <div className="flex between">
                    <div className="flex gap16">
                        <div>
                            <div className="text blockTitle">{this.getHeaderText()}</div>
                            <div className="comment text p2">{`${this.tr("expenses.lastChanges")} ${this._helper.date.toStr(new Date(), 'DD.MM.YYYY HH:mm')}`}</div>
                        </div>
                    </div>
                    <div className="flex gap16">
                        <SelectDateRange ref={el => this.selectDateRange = el} onForm={this.onForm.bind(this)} />
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"expenses.addMovement"}
                            onClick={this.openDialog.bind(this, "newFund")}
                        />
                        <ButtonIconSelect
                            translate={true}
                            items={[
                                { name: "expenses.addCommentDay", onClick: null },
                                { line: true },
                                { name: "expenses.downloadReportXLS", onClick: null },
                                { name: "expenses.print", onClick: null },
                            ]}
                        />
                    </div>
                </div>
                {selectedEndDate ? this.renderTablePeriod() : this.renderTable()}
            </div>
        );
    }
}
